module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("数据分析")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.\t什么是节目推荐指数？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "294px",
      "height": "220px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_1.png")
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2. 如何增加播放人数？")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "330px",
      "height": "200px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_2.png")
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "460px",
      "height": "190px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_3.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3. 如何提升节目完播率？")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4. 如何降低节目跳出率？")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "524px",
      "height": "290px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_4.png")
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("5. 如何提升节目留存率？")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "534px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_5.png")
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "330px",
      "height": "200px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_5.png")
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("6. 如何增加节目订阅量？")]), _vm._v(" "), _vm._m(10)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("喜马拉雅FM的节目推荐，采用的是智能算法。而哪个节目被推荐的更多？曝光给多少用户？则取决于节目的推荐指数。推荐指数越高，在榜单、分类排名、猜你喜欢、搜索等方面就会被更多地曝光。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("推荐指数主要由以下五个维度构成：")]), _c('br'), _vm._v("\n        1.\t"), _c('strong', [_vm._v("播放人数")]), _vm._v("：最近一周被多少人播放"), _c('br'), _vm._v("\n        2.\t"), _c('strong', [_vm._v("完播率")]), _vm._v("：节目被完整播放的比例"), _c('br'), _vm._v("\n        3.\t"), _c('strong', [_vm._v("跳出率")]), _vm._v("：用户在某段时间终止播放"), _c('br'), _vm._v("\n        4.\t"), _c('strong', [_vm._v("留存率")]), _vm._v("：两周后还有多少人在听"), _c('br'), _vm._v("\n        5.\t"), _c('strong', [_vm._v("订阅量")]), _vm._v("：月度新增的订阅用户\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("举个栗子小明的节目《小红说》最新数据如下："), _c('br'), _vm._v("\n        最近7天完播人数："), _c('strong', [_vm._v("20000")]), _c('br'), _vm._v("\n        最近7天节目完播率："), _c('strong', [_vm._v("50%")]), _c('br'), _vm._v("\n        最近7天节目跳出率："), _c('strong', [_vm._v("30%")]), _c('br'), _vm._v("\n        最近14天节目留存率："), _c('strong', [_vm._v("20%")]), _c('br'), _vm._v("\n        最近30天新增订阅量："), _c('strong', [_vm._v("3000")]), _c('br'), _c('br'), _vm._v("\n        那么《小红说》的节目推荐指数约等于：83分，全站排名前50，是不是已经非常棒了。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("增加订阅量提升播放人数")]), _c('br'), _vm._v("\n        拥有更多粉丝与订阅才能带来长期稳定的播放量。您可以在节目中提示听众点击”订阅“按钮订阅您的专辑哦，也可以分享节目给您的朋友们“求订阅”！\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("新节目上线立即分享")]), _c('br'), _vm._v("\n        当你的节目通过审核，收到提醒，此时是不是已经迫不及待地要与你的好友或者粉丝分享你的声音作品了呢？那就立刻分享到 微博、微信、QQ空间等，获取第一批高播放量。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("节目完播率就是说完整的听完整档节目的人数比例，节目不仅要让你的听众一见钟情，还要实实在在的长情。所以不能虎头蛇尾哦，一定要整档节目都能把你的听众吸引住哦。")]), _vm._v(" "), _c('br'), _c('br'), _c('strong', [_vm._v("要在最短时间抓住听众耳朵")]), _vm._v(" "), _c('br'), _vm._v("节目抓不抓耳，开头很重要。只有当音人声完美地结合时，能为节目起到锦上添花、画龙点睛的作用。节目开头引领听众走入丰富的节目中。一定要在1分钟内打动听众。想要打动听众，自己必须对节目有一个明晰的意境，定位准确。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("表达要有趣（生动鲜活）")]), _vm._v(" "), _c('br'), _vm._v("大多数人聊严肃类话题都是很无趣的，我不信你们上历史政治化学物理数学课没有打过瞌睡！深入浅出、生动有趣、一语中的的犀利表达一定会吸引听众的。\n        "), _c('br'), _vm._v("喜闻乐见：有趣，吐槽，别人比我惨……\n        "), _c('br'), _vm._v("有我：帮自己定义一个风格，例如，我是一个好人，有B格，有品位，有意思，有正义感……\n        "), _c('br'), _vm._v("有用：独特的视角，方法论，前因后果，细节\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("你了解自己的节目跳出率吗？")]), _c('br'), _vm._v("\n        一个节目如果有20分钟时间，我们会把它切成100份，这样我们就可以知道用户在收听的时候，在什么时间点跳出离开。主播有了这个数据，就可以对自己的节目进行优化。每个认证主播都可以在自己的数据中心查阅跳出率。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("通过跳出率发现问题，改善节目。")]), _c('br'), _vm._v("\n        很多节目，听众在1分钟不到的时候就跑了，这些节目的片花就有1分多钟长。所以我们建议主播片花可以做得短一点。主播可以经常去研究节目中高跳出率的部分，听众究竟为什么从这里“跑掉了”。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("什么是节目留存率？")]), _c('br'), _vm._v("\n        打个比方，本周你新增了100个粉丝，那么试想一下，一周以后还有多少人继续听着你的节目？两周以后呢？同样是这批人，四周以后呢？所以留存率一定是好节目的重要标准之一，你的节目留存情况如何？如果不是很理想，那么就应该思考一下如何改进节目质量啦！\n        "), _c('br'), _c('br'), _vm._v("您可以在数据中心里查阅留存率：\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("增加订阅量提升播放人数")]), _c('br'), _vm._v("\n        拥有更多粉丝与订阅才能带来长期稳定的播放量。您可以在节目中提示听众点击”订阅“按钮订阅您的专辑哦，也可以分享节目给您的朋友们“求订阅”！\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("通过合理的节目更新周期提升留存率")]), _vm._v(" "), _c('br'), _vm._v("要吸粉，要让听众持续的关注你的节目，就得有尽量固定的更新频率与周期，就像卖东西，要想销量好，客户总得知道你什么时候开张，什么时候打烊。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("通过更多的分享传播提升留存率")]), _vm._v(" "), _c('br'), _vm._v("分享出去，让自己的节目赢得更多粉丝吧！利用好你在其他网站的影响力。不浪费，全部用上。调动现有粉丝，让大家把你节目分享出去，获得更多人的关注，说不定，一大波新粉正在靠近呢。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("勤回复，多互动，增加忠实粉丝")]), _vm._v(" "), _c('br'), _vm._v("符合三观的，有趣，有益的，经常互动，并回粉。回复评论与粉丝互动啊，这是一开始最有效最务实的方法，不要多考虑，直接上。努力吧，幸福总在下一个拐角。可以偶尔在节目中读出以往节目中的留言，还可以事先设定一个话题，让大家来留言互动。让你与听众走的更近一些吧。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("要记得常常和听众互动哟")]), _c('br'), _vm._v("\n        沉默永远是关注度的最大杀手！\n\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("勤回复：")]), _vm._v(" "), _c('br'), _vm._v("符合三观的，有趣，有益的，经常互动，并回粉。回复评论与粉丝互动啊，这是一开始最有效最务实的方法，不要多考虑，直接上。努力吧，幸福总在下一个拐角。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("线上互动：")]), _vm._v(" "), _c('br'), _vm._v("可以偶尔在节目中读出以往节目中的留言，还可以事先设定一个话题，让大家来留言。安抚人心。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("给他人点赞和评论：")]), _vm._v(" "), _c('br'), _vm._v("点赞和评论是沟通，要有针对性。也不能瞎点，要按兴趣。在自己已经粉的高手里，点赞和沟通。这样不仅可以交到更多的主播朋友还可能吸引更多的粉丝哦。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("分享传播也很重要")]), _vm._v(" "), _c('br'), _vm._v("分享出去，让自己的节目赢得更多粉丝吧！利用好你在其他网站的影响力。不浪费，全部用上。调动现有粉丝，让大家把你节目分享出去，获得更多人的关注，说不定，一大波新粉正在靠近呢。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("提醒你的听众点击“订阅节目”")]), _vm._v(" "), _c('br'), _vm._v("粉丝很多，订阅很少？不如在你的节目中提示听众点击“订阅节目”按钮，为你增加订阅量。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44d49d32!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/DataAnalysis.vue
// module id = 379
// module chunks = 0